<!--header-->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>PROSCAN Status</ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--proscan status image-->
  <pinch-zoom class="height-100">
    <img alt="PROSCAN Status" [src]="status_url">
  </pinch-zoom>
  <!--Button to update status image-->
  <ion-fab vertical="bottom" (click)="doRefresh()" horizontal="end" slot="fixed">
    <ion-fab-button color="dark">
      <ion-icon *ngIf="!refreshIcon" name="refresh"></ion-icon>
      <ion-spinner *ngIf="refreshIcon" name="dots"></ion-spinner>
    </ion-fab-button>
  </ion-fab>

</ion-content>
